appSubcategories.classy.controller({
    name: "ApplicationSubcategoriesController",
    inject: ["$scope", "$rootScope", "SchoolSubcategoriesModelService", "authServiceFactory", "HelpSystemModelService", "standardCudArrayFactory"],
    init: function() {
        this.$.arrayCud = new this.standardCudArrayFactory(this.SchoolSubcategoriesModelService,
            this.authServiceFactory.getAuth().schoolID, this.SchoolSubcategoriesModelService.get(), this, []);
        this.$.SchoolSubcategoriesModelService = this.SchoolSubcategoriesModelService;
        this.$rootScope.model = this.SchoolSubcategoriesModelService;
        this.$.HelpSystemModelService = this.HelpSystemModelService;
        let self = this;
        this.$.sortableOptions = {
            stop: function(e, ui) {
                self.$.newOrder = [];
                $(".graderow").each(function(index) {
                    self.$.newOrder[index] = $(this).attr("id");
                });
                for (let key in self.$.newOrder) {
                    for (let key2 in self.$.items) {
                        if (self.$.newOrder[key] === self.$.items[key2].recordID) {
                            self.$.items[key2].order = parseInt(key) + 1;
                        }
                    }
                }
                self.$.$apply();
            }
        };
    },
    startSaveProcess: function(scope, instance, form) {
        if (form.$valid) {
            let parent = this;
            instance.options.factor  = .3;
            this.$.arrayCud.toggleEditItem(this.$.items.length - 1);
            this.SchoolSubcategoriesModelService.put(this.authServiceFactory.getAuth().schoolID, this.$.items, instance).then((results) => {
                parent.$.items = results.data;
            });
        } else {
            instance.stop(-1);
        }
    },
    del: function(index) {
        if (typeof this.$.items[index].recordID !== "undefined") {
            this.$.items[index].active = 0;
            this.$.arrayCud.toggleEditItem(index);
        } else {
            this.$.arrayCud.editItem.pop();
            this.$.items.pop();
        }
    }
});
